import { z } from "zod";
import { DTOExportJobResponseLegacy } from "../../dto";
import { RequestExecutor } from "../../transport";

export class ExporterJobsEndpoint {
  constructor(private readonly requestExecutor: RequestExecutor) {}

  list(workspaceId: string) {
    return this.requestExecutor.json(`/codegen/workspaces/${workspaceId}/jobs`, z.any());
  }

  get(workspaceId: string, jobId: string) {
    return this.requestExecutor.json(`/codegen/workspaces/${workspaceId}/jobs/${jobId}`, DTOExportJobResponseLegacy);
  }
}
